import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ExternalSystemsConfigService {
	private static readonly productionHostName: Array<string> = [
		'vm-ib-front.rs.ru',
		'online.rsb.ru',
		'online-test-preprod.rsb.ru',
		// 'online-test.rsb.ru'
		// 'localhost'
	];

	constructor() { }

	public static get chatSettingsFile(): string {
		return ExternalSystemsConfigService.isProduction()
			? '/chat/settings.json'
			: '/chat/settings-test.json';
	}

	public static get insuranceSectionFrameSrc(): string {
		return ExternalSystemsConfigService.isProduction()
			? // боевая ссылка
			'https://ibbrs.rsins.ru/new/'
			: // тестовая ссылка (пока все боевое)
			'https://ibbrs.rsins.ru/new/';
	}

	public static get creditHistoryFrameSrc(): string {
		return ExternalSystemsConfigService.isProduction()
			? // боевая ссылка
			'https://private.rs-cb.ru/ext-rating-v2.aspx'
			: // тестовая ссылка
			'http://private-test.rs-cb.ru/ext-rating-v2.aspx';
	}

	public static isProduction(): boolean {
		return !!ExternalSystemsConfigService.productionHostName.find(
			(x: string) => x === location.hostname,
		);
	}
}
